var _require = require('web3-utils'),
    toBN = _require.toBN;

function toDecimal(weiInput, decimals) {
  var wei = toBN(weiInput.toString());
  var base = toBN('10').pow(toBN(decimals.toString()));
  var baseLength = base.toString().length - 1 || 1;
  var fraction = wei.mod(base).toString(10);

  while (fraction.length < baseLength) {
    fraction = "0".concat(fraction);
  }

  fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  var whole = wei.div(base).toString(10);
  var value = "".concat(whole).concat(fraction == '0' ? '' : ".".concat(fraction));
  return value;
}

module.exports.toDecimal = toDecimal;